<template>
<div class="cart-wrap" :class="{ 'cart-wrap--mini-cart-open': miniCartExpanded }">
        <a href="/store/cart.php" class="site-header__menu-item site_header__cart" :aria-label="cartAriaLabel" title="Your cart" @keydown="onKeyPress" @click.prevent="handleClick" @mouseenter="clearInitCartTimeout">

            <svg v-if="webserviceCartqty >= 1000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.27 28.99" height="35" width="35" class="icon__cart_smile">
                <path d="M26.35 26.35a2.64 2.64 0 1 0 .77-1.86 2.54 2.54 0 0 0-.77 1.86zM7.91 26.35a2.64 2.64 0 1 0 .77-1.86 2.54 2.54 0 0 0-.77 1.86z" />
                <path d="M33.87 3a1.27 1.27 0 0 0-.93-.39H8.21q0-.15-.09-.53L8 1.5a3.64 3.64 0 0 0-.15-.5 1.64 1.64 0 0 0-.27-.5 1.32 1.32 0 0 0-.41-.36A1.26 1.26 0 0 0 6.58 0H1.31a1.27 1.27 0 0 0-.92.39 1.29 1.29 0 0 0 0 1.83 1.27 1.27 0 0 0 .93.39h4.2l3.64 16.97-.42.78q-.38.7-.61 1.22a2.26 2.26 0 0 0-.23.81 1.33 1.33 0 0 0 1.32 1.32H30.3a1.32 1.32 0 0 0 0-2.64H11.36a4 4 0 0 0 .49-1.32 2.22 2.22 0 0 0-.05-.45q-.05-.25-.12-.55t-.09-.44l21.5-2.51a1.28 1.28 0 0 0 .84-.44 1.3 1.3 0 0 0 .33-.87V4a1.27 1.27 0 0 0-.39-1zm-9.75 3a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm-6 0a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm10.4 5a9.61 9.61 0 0 1-7.38 3 9.61 9.61 0 0 1-7.37-3 .61.61 0 0 1 .11-.84.57.57 0 0 1 .77 0 6.7 6.7 0 0 0 1.61 1.3 9.32 9.32 0 0 0 4.88 1.29 8.56 8.56 0 0 0 6.51-2.58.57.57 0 0 1 .8-.1.61.61 0 0 1 .07.93z" /></svg>
            
            <span v-if="webserviceCartqty < 1000" class="cart-qty__container">

                <svg v-if="cartRetrieved == false" xmlns="http://www.w3.org/2000/svg" viewBox="1510.724 16 34.261 28.99" height="35" width="35" class="icon__cart-preload">
                    <path d="M1537.078 42.354a2.636 2.636 0 1 0 .772-1.864 2.54 2.54 0 0 0-.772 1.864z" />
                    <path d="M1544.593 19.026a1.266 1.266 0 0 0-.927-.39h-24.727q-.023-.145-.095-.526t-.113-.608a3.632 3.632 0 0 0-.154-.545 1.642 1.642 0 0 0-.27-.5 1.314 1.314 0 0 0-.41-.32 1.257 1.257 0 0 0-.588-.133h-5.27a1.267 1.267 0 0 0-.927.39 1.293 1.293 0 0 0 0 1.854 1.267 1.267 0 0 0 .927.39h4.2l3.644 16.943q-.04.084-.422.784t-.607 1.225a2.26 2.26 0 0 0-.226.812 1.335 1.335 0 0 0 1.32 1.32h21.08a1.318 1.318 0 0 0 0-2.637h-18.94a3.975 3.975 0 0 0 .492-1.317 2.224 2.224 0 0 0-.052-.453q-.05-.247-.123-.546t-.093-.443l21.5-2.512a1.278 1.278 0 0 0 .844-.443 1.3 1.3 0 0 0 .33-.875v-10.54a1.268 1.268 0 0 0-.395-.93z" />
                    <path d="M1518.63 42.354a2.636 2.636 0 1 0 .772-1.864 2.537 2.537 0 0 0-.772 1.864z" /></svg>

                <svg v-else-if="webserviceCartqty < 1000 && webserviceCartqty > 0" xmlns="http://www.w3.org/2000/svg" viewBox="1510.724 16 34.261 28.99" height="35" width="35" class="icon__cart">
                    <path d="M1537.078 42.354a2.636 2.636 0 1 0 .772-1.864 2.54 2.54 0 0 0-.772 1.864z" />
                    <path d="M1544.593 19.026a1.266 1.266 0 0 0-.927-.39h-24.727q-.023-.145-.095-.526t-.113-.608a3.632 3.632 0 0 0-.154-.545 1.642 1.642 0 0 0-.27-.5 1.314 1.314 0 0 0-.41-.32 1.257 1.257 0 0 0-.588-.133h-5.27a1.267 1.267 0 0 0-.927.39 1.293 1.293 0 0 0 0 1.854 1.267 1.267 0 0 0 .927.39h4.2l3.644 16.943q-.04.084-.422.784t-.607 1.225a2.26 2.26 0 0 0-.226.812 1.335 1.335 0 0 0 1.32 1.32h21.08a1.318 1.318 0 0 0 0-2.637h-18.94a3.975 3.975 0 0 0 .492-1.317 2.224 2.224 0 0 0-.052-.453q-.05-.247-.123-.546t-.093-.443l21.5-2.512a1.278 1.278 0 0 0 .844-.443 1.3 1.3 0 0 0 .33-.875v-10.54a1.268 1.268 0 0 0-.395-.93z" />
                    <path d="M1518.63 42.354a2.636 2.636 0 1 0 .772-1.864 2.537 2.537 0 0 0-.772 1.864z" /></svg>

                <svg v-else-if="webserviceCartqty < 1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="35" height="35" style="enable-background:new 0 0 35 35;fill:#2e2d2b"><path d="M26.9 29.6c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.7-1.2 2.7-2.7 0-1.5-1.2-2.7-2.7-2.7a2.732 2.732 0 0 0-2.7 2.7zM8.1 29.6c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.7-1.2 2.7-2.7 0-1.5-1.2-2.7-2.7-2.7a2.732 2.732 0 0 0-2.7 2.7zM34.6 5.8c-.2-.3-.6-.4-.9-.4-1.2 0-1.3 1.2-1.3 1.2v9.2c0 .9-.5.9-1.4 1-1 .1-19.8 2.2-19.8 2.2L8.4 5.4c0-.1 0-.3-.1-.5 0-.3-.1-.5-.1-.6-.1-.3-.1-.4-.2-.6 0-.2-.1-.4-.3-.5-.1-.2-.2-.3-.4-.4-.2-.1-.4-.1-.6-.1H1.3c-.3 0-.7.1-.9.4-.5.5-.5 1.3 0 1.9.2.2.6.4.9.4h4.3l3.7 17.3c0 .1-.2.3-.4.8-.3.5-.5.9-.6 1.3-.1.3-.2.5-.2.8 0 .7.6 1.3 1.3 1.3H31c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3H11.6c.2-.4.4-.9.5-1.3 0-.2 0-.3-.1-.5 0-.2-.1-.4-.1-.6 0-.2-.1-.4-.1-.5l22-2.6c.3 0 .6-.2.9-.5.2-.2.3-.6.3-.9V6.7c0-.3-.1-.7-.4-.9z"/><path d="M16.8 8.7c0-2.7 1.2-4.2 3.1-4.2C21.8 4.5 23 6 23 8.7s-1.1 4.2-3.1 4.2c-2-.1-3.1-1.6-3.1-4.2zm4.7-.1c0-1.9-.6-2.9-1.7-2.9s-1.7 1-1.7 2.9.6 2.9 1.7 2.9c1.1.1 1.7-.9 1.7-2.9z"/></svg>

    
                <span v-if="(webserviceCartqty < 1000) && (webserviceCartqty > 0)" class="site_header__cart_count">
                    {{webserviceCartqty}}
                </span>
            </span>
        </a>

        <button
            v-if="minicartEnabled && cartToggleVisible"
            type="button"
            class="site_header__cart-menu-toggle visually-hidden"
            aria-label="Open mini cart menu"
            aria-haspopup="true"
            :aria-expanded="miniCartExpanded ? 'true' : 'false'"
            :aria-controls="cartMenuId"
            ref="cartMenuToggle"
            @click.stop="handleToggleClick"
            @keydown="onKeyPress"
        >
        </button>
        <div id="mini-cart-wrapper">
            <div class="mobile-mc-overlay" @click="handleClick"></div>
            <mini-cart v-if="minicartEnabled" :open="miniCartExpanded" :menu-id="cartMenuId" :minicartExclusions="minicartExclusions"  @cart-items-updated="cartUpdateComplete" @mini-cart-close="closeMiniCart(true)" :isMobile="isMobile" ref="miniCartRef"
                :buyNowClicked="buyNowClicked" @buyNowClicked="buyNowClicked = true" @cartItemsSet="setCartItems"
            ></mini-cart>
        </div>

        <buy-now-modal
            v-if="buyNowClicked"
            @close="buyNowClicked = false"
            :multiple="true"
            :items="cartitems"
            referrer="minicart"
            ></buy-now-modal>
    </div>
</template>

<script>
import miniCart from './mini-cart.vue';
import BuyNowModal from '../../app/store/detail/BuyNowModal.vue';

export default {
    props: {
        minicartEnabled: {
            default: false,
            type: Boolean
        },
        minicartExclusions: {
            default: '',
            type: String
        },
        minimobileEnabled: {
            default: false,
            type: Boolean
        }
    },
    components: { miniCart, BuyNowModal },
    data() {
        return {
            isMobile: false,
            cartToggleVisible: false,
            webserviceCartqty: 0,
            cartRetrieved: false,
            buyNowClicked: false,
            cartitems: [],
            miniCartExpanded: false,
            cartMenuId: 'site-header-mini-cart-menu',
        };
    },
    mounted(){
        this.updateViewportFlags();
        window.addEventListener('resize', this.updateViewportFlags);
        events.$on('refreshCartQty', this.updateCartItems); 

        // If mini cart is disabled, fall back to cookie qty
        if(!this.minicartEnabled){
            this.cartRetrieved = true;
            var fallbackQty = document.cookie.split('; ').map(cookie => cookie.split('=')).find(([name]) => name === 'sws_cartqty')?.[1] || null;
            if(fallbackQty){
                this.webserviceCartqty = fallbackQty;
            } else {
                this.webserviceCartqty = 0;
            }
        } else {
            this.$el.addEventListener('focusout', this.handleCartFocusOut);
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateViewportFlags);
        if (this.minicartEnabled) {
            this.$el.removeEventListener('focusout', this.handleCartFocusOut);
        }
    },
    methods: {

        updateViewportFlags() {
            const width = window.innerWidth;
            this.isMobile = width <= 767;
            this.cartToggleVisible = width >= 566;
        },

        setCartItems(newCartitems) {
            this.cartitems = newCartitems;
        },

        clearInitCartTimeout() {
            this.$refs.miniCartRef.clearTimeout();
        },

        updateCartItems(){
            this.$refs.miniCartRef.buildMinicart();
        },

        cartUpdateComplete(cartItems){
            this.webserviceCartqty = cartItems;
            this.cartRetrieved = true;
        },

        // desktop click vs mobile menu open
        handleClick(){
            var currentUrl = window.location.href;
            if(window.innerWidth <= 566 && this.minimobileEnabled && this.webserviceCartqty > 0 && !currentUrl.includes("cart.php") && !currentUrl.includes("checkout")){
                var cartWrap = document.querySelector('.cart-wrap');
                if(cartWrap.classList.contains('mc-mobile-open')){
                    document.body.classList.remove('noscroll');
                    cartWrap.classList.remove('mc-mobile-open-animate','mc-mobile-open');
                } else {
                    cartWrap.classList.add('mc-mobile-open');
                    setTimeout(function(){
                        // animate
                        cartWrap.classList.add('mc-mobile-open-animate');
                        document.body.classList.add('noscroll');
                    }, 100);
                }
            } else {
                var cartIcon = document.querySelector('.site_header__cart');
                window.location = cartIcon.getAttribute('href');
            }
        },
        openMiniCart() {
            if (!this.minicartEnabled || window.innerWidth < 566) {
                return;
            }
            this.miniCartExpanded = true;
        },
        closeMiniCart(focusToggle = false) {
            if (this.$el.classList.contains('mc-mobile-open')) {
                document.body.classList.remove('noscroll');
                this.$el.classList.remove('mc-mobile-open-animate', 'mc-mobile-open');
                if (focusToggle) {
                    this.$el.querySelector('.site_header__cart')?.focus();
                }
                return;
            }
            this.miniCartExpanded = false;
            if (focusToggle && this.$refs.cartMenuToggle) {
                this.$refs.cartMenuToggle.focus();
            } else if (focusToggle) {
                this.$el.querySelector('.site_header__cart')?.focus();
            }
        },
        handleCartFocusOut(event) {
            if (!this.miniCartExpanded) {
                return;
            }
            if (event.relatedTarget && this.$el.contains(event.relatedTarget)) {
                return;
            }
            this.closeMiniCart();
        },
        handleToggleClick(event) {
            event.stopPropagation();
            if (this.miniCartExpanded) {
                this.closeMiniCart(true);
                return;
            }
            this.openMiniCart();
        },
        onKeyPress(event) {
            let key = event.key;

            const onToggle = event.target === this.$refs.cartMenuToggle;
            const onCartLink = event.target.classList.contains('site_header__cart');
            if (!onToggle && !onCartLink) {
                return;
            }
            if (onToggle && (key === 'ArrowDown' || key === ' ' || key === 'Enter')) {
                event.preventDefault();
                this.openMiniCart();
                return;
            }
            if (key === 'Escape' && (this.miniCartExpanded || this.$el.classList.contains('mc-mobile-open'))) {
                event.preventDefault();
                this.closeMiniCart(true);
                return;
            }

            if (key !== 'Tab' || window.innerWidth < 768) {
                return;
            }

            if (onCartLink && !event.shiftKey && this.$refs.cartMenuToggle) {
                event.preventDefault();
                this.$refs.cartMenuToggle.focus();
            } else if (onCartLink && event.shiftKey) {
                const accountButton = document.querySelector('button[data-navigation="Account Button"]');
                if (accountButton) {
                    event.preventDefault();
                    accountButton.focus();
                }
            } else if (onToggle && !event.shiftKey) {
                if(this.miniCartExpanded){
                    return;
                }
                const nextTab = document.querySelector('a[data-navigation="Shop By Category"]');
                if (nextTab) {
                    event.preventDefault();
                    nextTab.focus();
                }
            } else if (onToggle && event.shiftKey) {
                event.preventDefault();
                document.querySelector('.site_header__cart')?.focus();
            }
        }
    },
    computed: {
        cartAriaLabel() {
            const itemCount = Number(this.webserviceCartqty) || 0;
            const itemLabel = itemCount === 1 ? '1 item' : `${itemCount} items`;

            return `Your cart, ${itemLabel}. Click or press enter to visit the Shopping Cart page.`;
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" type="text/scss" scoped>

    @import '~@sweetwater/sass-resources/sass';
    
    @media screen and (min-width: 566px) {
        .cart-wrap:hover {
            background: hsla(34,17%,92%,.5);
            outline-offset: -4px;
            position: relative;

            .mc {
                display: block;
            }
        }
    }

    @media screen and (max-width: 568px) {
        a.site_header__cart {
            width: 52px;
        }
    }

    .cart-wrap,
    .cart-wrap--mini-cart-open {
        display: flex;
        position: relative;

        &:has(> a.site_header__cart:focus-visible){
            background-color: tint($light-grey, 20%);
            outline: 2px solid var(--blue);
            outline-offset: -2px;
            border-radius: 5px;
        }
        &:has(> .site_header__cart-menu-toggle:focus-visible) {
            outline: 2px solid var(--blue);
            outline-offset: -2px;
            border-radius: 5px;
        }

        > a.site_header__cart:focus-visible,
        > .site_header__cart-menu-toggle:focus-visible {
            outline: none;
        }
    }

    .icon__cart, .icon__cart_smile {
        fill: $green;
    }

    .icon__cart-preload {
        fill: #efefef;
    }

    .icon__cart_empty {
        fill: #2E2D2B;
    }

    a.site_header__cart {
        position: relative;
        width: 68px;
    }

    .site_header__cart_count {
        color: #fff;
        font-size: 12px;
        left: 61%;
        position: absolute;
        top: -1px;
        transform: translate(-50%, 50%);
    }

    .cart-qty__container {
        display: inline-block;
        position: relative;
        pointer-events: none;
    }
    

</style>
